import type { Layout } from './layout.js';

const all = { audience: 'all', hideOnMobile: false } as const;

/** A server's overview page as Hearth draws it without customisation. Ids are fixed. */
export const DEFAULT_SERVER_OVERVIEW_LAYOUT: Layout = {
  version: 1,
  nodes: [
    { id: 'srv-alerts', type: 'server-alerts', props: {} },
    { id: 'srv-stats', type: 'server-stats', props: { showAttention: true, visibility: all } },
    {
      id: 'srv-cols',
      type: 'columns',
      props: { count: 2, ratio: '1:2', gap: 'lg', visibility: all },
      children: [
        {
          id: 'srv-col-a',
          type: 'column',
          props: {},
          children: [
            {
              id: 'srv-facts',
              type: 'server-facts',
              props: {
                title: 'Server',
                fields: ['status', 'address', 'players', 'version', 'game', 'location', 'sftp'],
                visibility: all,
              },
            },
            {
              id: 'srv-actions',
              type: 'server-quick-actions',
              props: {
                title: 'Quick actions',
                actions: ['backup', 'console', 'files', 'startup'],
                visibility: all,
              },
            },
          ],
        },
        {
          id: 'srv-col-b',
          type: 'column',
          props: {},
          children: [
            {
              id: 'srv-activity',
              type: 'server-activity',
              props: { title: 'Recent activity', limit: 8, visibility: all },
            },
          ],
        },
      ],
    },
  ],
};

/** A server's console page as Hearth draws it without customisation. */
export const DEFAULT_SERVER_CONSOLE_LAYOUT: Layout = {
  version: 1,
  nodes: [
    { id: 'con-alerts', type: 'server-alerts', props: {} },
    { id: 'con-console', type: 'server-console', props: {} },
    { id: 'con-charts', type: 'server-usage-charts', props: { visibility: all } },
  ],
};
